import type { CmsBlock } from "@gaole/shared";
import { Link } from "react-router-dom";

export function CmsBlockRenderer({ blocks }: { blocks: CmsBlock[] }) {
  return (
    <div className="cms-blocks space-y-4">
      {blocks
        .filter((b) => b.enabled !== false)
        .map((block) => {
          switch (block.kind) {
            case "heading":
              return block.level === 1 ? (
                <h1 key={block.id} className="font-display text-2xl font-bold">
                  {block.text}
                </h1>
              ) : (
                <h2 key={block.id} className="font-display text-lg font-semibold">
                  {block.text}
                </h2>
              );
            case "paragraph":
              return (
                <p key={block.id} className="whitespace-pre-wrap text-sm leading-relaxed text-white/80">
                  {block.text}
                </p>
              );
            case "image":
              if (!block.url) return null;
              return (
                <figure key={block.id} className="overflow-hidden rounded-2xl border border-white/10">
                  <img src={block.url} alt={block.alt ?? ""} className="w-full object-cover" />
                  {block.caption ? (
                    <figcaption className="px-3 py-2 text-[11px] text-white/50">{block.caption}</figcaption>
                  ) : null}
                </figure>
              );
            case "quote":
              return (
                <blockquote
                  key={block.id}
                  className="border-l-2 border-brand-pink/60 pl-4 text-sm italic text-white/75"
                >
                  {block.text}
                  {block.attribution ? (
                    <footer className="mt-2 text-[11px] not-italic text-white/45">— {block.attribution}</footer>
                  ) : null}
                </blockquote>
              );
            case "divider":
              return <hr key={block.id} className="border-white/10" />;
            case "cta": {
              const external = block.href.startsWith("http");
              const className =
                "inline-flex rounded-xl bg-gradient-brand px-4 py-2.5 text-xs font-semibold text-white";
              return external ? (
                <a key={block.id} href={block.href} target="_blank" rel="noreferrer" className={className}>
                  {block.label}
                </a>
              ) : (
                <Link key={block.id} to={block.href} className={className}>
                  {block.label}
                </Link>
              );
            }
            default:
              return null;
          }
        })}
    </div>
  );
}
